<div class="task-list">
  <div class="header">
    <h2>Tasks list</h2>
    <a class="refresh" (click)="loadTaskList()">
      <mat-icon>sync</mat-icon>
    </a>
  </div>
  @if (tasks?.length) {
    <table mat-table [dataSource]="tasks" class="tasks">
      <ng-container matColumnDef="taskType">
        <th mat-header-cell *matHeaderCellDef> Task type </th>
        <td mat-cell *matCellDef="let task"> {{getTaskTypeLabel(task)}} </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef> ID </th>
        <td mat-cell *matCellDef="let task"> {{task.id}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let task"> {{task.status}} </td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let task" class="action-column">
          @if (isCancellable(task)) {
            <button type="button" mat-raised-button color="primary" (click)="cancel(task)"
            >Cancel</button>
          }
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  }
</div>
